import axios from "axios";
import Vue from "vue";

axios.interceptors.request.use((request) => {
  request.headers.common["content-language"] = "es";
  request.headers.common.utcoffset = "-300";
  return request;
});

axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => Promise.reject(error.response),
);

Vue.prototype.$axios = axios;
